import axios from 'axios';
import type { SignInResponse } from '../types/customer';
import { attachRefreshInterceptor } from './axiosInterceptorFactory';

const customerServiceURL = import.meta.env.VITE_CUSTOMER_SERVICE_API_URL;

const instance = axios.create({
  baseURL: import.meta.env.VITE_ORDER_SERVICE_API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
  timeout: 20000,
});

// Attach shared 401 refresh interceptor
// Order service uses customer service for auth (shared cookies)
const { setCallbacks } = attachRefreshInterceptor(instance, async () => {
  const { data } = await axios.get<SignInResponse>(
    `${customerServiceURL}/api/public/auth/refresh-token`,
    { withCredentials: true }
  );
  return data;
});

/**
 * Register callbacks for AuthContext to sync React state after silent refresh
 */
export function registerOrderServiceInterceptorCallbacks(
  onSuccess: ((result: SignInResponse) => void) | null,
  onFailure: (() => void) | null
) {
  setCallbacks(onSuccess, onFailure);
}

export default instance;
